let lenis;

class InertiaScroll {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    if (window.matchMedia('(min-width: 769px)').matches) {
      lenis = new Lenis({
        lerp: 2, // 慣性の強さ
        duration: 0.8, // スクロールアニメーションの時間
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      
      requestAnimationFrame(raf);
    }
  }
}
